
export const SET_PAGE_WIDGET = 'page-config/set-page-widget';
export const REMOVE_PAGE_WIDGET = 'page-config/remove-page-widget';
export const SET_PAGE_CONFIG = 'page-config/set-page-config';
export const SET_PUBLISHED_PAGE_CONFIG = 'page-config/set-published-page-config';
export const SET_CONTENT_TOOLBAR = 'page-config/set-content-toolbar';
export const TOGGLE_CONTENT = 'page-config/toggle-content';
export const TOGGLE_CONTENT_TOOLBAR_EXPANDED = 'page-config/toogle-content-toolbar-expanded';
export const SET_SEARCH_FILTER = 'page-config/set-search-filter';
